import { AxiosInstance } from 'axios';
import { requestParser, ordersParse } from './utils';
import { EventPoints } from './types';
import { RequestPayloadData } from './utils';

const postOrderRequestData = (api: AxiosInstance) => ({
  postOrderRequest: async (payload: RequestPayloadData): Promise<any> => {
    const result = await api.post(EventPoints.ORDER_CREATE, {
      data: requestParser(payload),
    });
    return result;
  },
});

const getOrdersData = (api: AxiosInstance) => ({
  getOrders: async (params: any = { limit: 300 }): Promise<any> => {
    const { data } = await api.get(EventPoints.ORDERS_GET, {
      params,
    });
    return { ...data, data: ordersParse(data.data) };
  },
});

const postCancelRequestData = (api: AxiosInstance) => ({
  postCancelRequest: async (id: string): Promise<any> => {
    const result = await api.post(`order/${id}/cancel`);
    return result;
  },
});

const oredersService = (api: AxiosInstance) => {
  if (!api) throw new Error('There is no HTTP client');
  return {
    ...postOrderRequestData(api),
    ...getOrdersData(api),
    ...postCancelRequestData(api),
  };
};

export default oredersService;



// WEBPACK FOOTER //
// ./src/services/orders/oredersService.ts